<!--
 The DBC list component's display logic utilizes the Bootstrap d-none class instead of *ngIf
 to prevent unnecessary re-rendering of iframes, which would otherwise result in additional API calls.
-->

<!-- Mobile App Download Nudge -->
<app-download-cards-app-mobile-nudge (bannerClosed)="onBottomNudgeClosed()"></app-download-cards-app-mobile-nudge>

<app-skeleton-loader
    [ngClass]="showSkeletonLoader && (currentScreen === DBC_SCREENS.LIST) ? '' : 'd-none'"
></app-skeleton-loader>

<div
    [ngClass]="!showSkeletonLoader && !noDbcExists() && (currentScreen === DBC_SCREENS.LIST || currentScreen === DBC_SCREENS.SHARE) ? '' : 'd-none'"
    class="list-container d-flex flex-column justify-content-center"
    id="list-container"
>
    <swiper-container
        #swiperContainer
        (swiperslidechange)="onSlideChange($event)"
        [config]="swiperConfig"
        appSwiper
        class="mySwiper"
        init="false"
    >
        <swiper-slide
            (click)="switchScreen(DBC_SCREENS.SHARE)"
            *ngFor="let dbc of dbcList; let i = index"
            class="bg-white"
        >
            <button class="edit-button" (click)="openEditModal($event)">
                <img 
                    class="edit-img"
                    src="/img/icons/edit-button.svg"
                    alt="Edit card"
                />
            </button>
            <!-- Shadow DOM container -->
            <div class="shadow-container iframe-container" [id]="dbc.id"></div>
        </swiper-slide>

        <swiper-slide *ngIf="dbcListResult?.next" class="bg-white">
            <div class="show-more-container">
                <div
                    (click)="getMoreCards()"
                    *ngIf="!isFetchingList"
                    class="add-card"
                >
                    <div class="add-card-text">Show More Cards</div>
                </div>
                <div *ngIf="isFetchingList">
                    <img
                        alt="Loading..."
                        class="loading-gif"
                        src="loader.gif"
                    />
                </div>
            </div>
        </swiper-slide>
    </swiper-container>

    <div>
        <!-- Empty div for center alignment -->
    </div>
    <!-- Add bottom navigation menu bar -->
    <app-bottom-nav [disableShareCardOption]="selectedDbc == null" (bottomNavButtonClicked)="onShareButtonClicked()">
    </app-bottom-nav>
</div>

<mobile-drawer
    [isDrawerOpen]="currentScreen === DBC_SCREENS.SHARE"
    (onOutsideClick)="switchScreen(DBC_SCREENS.LIST)"
>
    <share-screen-component *ngIf="currentScreen === DBC_SCREENS.SHARE"
        (closeScreen)="switchScreen(DBC_SCREENS.LIST)"
        (shareCancelled)="onShareCancelled()"
        [selectedDbc]="selectedDbc"
    ></share-screen-component>
</mobile-drawer>

<div *ngIf="currentScreen === DBC_SCREENS.CAPTURE">
    <app-image-capture
        (closeScreen)="switchScreen(DBC_SCREENS.LIST)"
    ></app-image-capture>
</div>

<div *ngIf="currentScreen === DBC_SCREENS.LEAD_LIST">
    <app-lead-list
        (closeScreen)="switchScreen(DBC_SCREENS.LIST)"
    ></app-lead-list>
</div>

<div
    *ngIf="!isFetchingList && noDbcExists() && (isLoggedIn$ | async)"
    class="h-100"
>
    <div class="empty-state-container">
        <div class="default-text-block p-3 d-flex flex-column">
            <div class="name-block">
                Welcome {{ user?.first_name | truncate: 40 }},
            </div>

            <div class="info-text">No digital business card created yet</div>
        </div>
        <ng-container *ngTemplateOutlet="noCardsTemplate"></ng-container>
    </div>
</div>

<ng-template #noCardsTemplate>
    <div class="no-cards-body p-4">
        <span>
            <img
                alt="No DBCs found"
                class="no-cards-svg"
                src="assets/empty-state.png"
            />
        </span>
        <span class="mt-1 no-cards-text">
            Go to dashboard & create your first digital business card to start
            sharing it
        </span>
    </div>
    <div class="sticky-button-container">
        <button (click)="handleRoutingToDashboard()" class="sticky-button">
            Go to Cards dashboard
        </button>
    </div>
</ng-template>
